module.exports = __webpack_public_path__ + "static/LoriCannon_Headshot-243107e6c87588c77499e1b031a95d62.png";